__turbopack_context__.v({
  "hideScrollbar": "Box-module__k-PU6a__hideScrollbar",
});
